import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { JobQualificationsService } from '../job-qualifications.service';
import * as jobQualificationActions from '../actions/job-qualifications.actions';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';
import { Store } from '@ngrx/store';

@Injectable()
export class JobQualificationsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _service: JobQualificationsService,
        private readonly _store: Store
    ) {}

    getJobQualifications$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadQualifications),
            switchMap((action) => {
                return this._service.getRequirements(action.jobId).pipe(
                    map((requirements) =>
                        jobQualificationActions.loadQualificationsSuccess({ qualifications: requirements })
                    ),
                    catchError((result) => {
                        this._store.dispatch(showToasterMessage({ message: 'Failed to load Job Qualifications.' }));
                        return of(jobQualificationActions.loadQualificationsFailure({ error: result }));
                    })
                );
            })
        );
    });

    getJobQualificationChanges$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadQualificationChanges),
            switchMap((action) => {
                return this._service.getChanges(action.jobId).pipe(
                    map((changes) => jobQualificationActions.loadQualificationChangesSuccess({ changes: changes })),
                    catchError((result) => {
                        this._store.dispatch(
                            showToasterMessage({ message: 'Failed to load Job Qualification Changes.' })
                        );
                        return of(jobQualificationActions.loadQualificationChangesFailure({ error: result }));
                    })
                );
            })
        );
    });

    getAvailableSkills$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadAvailableSkills),
            switchMap((action) => {
                return this._service
                    .getAvailableSkills(action.professionId, action.expertiseId, action.clinicalTrackId)
                    .pipe(
                        map((skills) => jobQualificationActions.loadAvailableSkillsSuccess({ skills: skills })),
                        catchError((result) => {
                            this._store.dispatch(showToasterMessage({ message: 'Failed to load Available Skills.' }));
                            return of(jobQualificationActions.loadAvailableSkillsFailure({ error: result }));
                        })
                    );
            })
        );
    });

    getAvailableCerts$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.loadAvailableCerts),
            switchMap((action) => {
                return this._service
                    .getAvailableCerts(action.professionId, action.expertiseId, action.clinicalTrackId)
                    .pipe(
                        map((certs) => jobQualificationActions.loadAvailableCertsSuccess({ certs: certs })),
                        catchError((result) => {
                            this._store.dispatch(
                                showToasterMessage({ message: 'Failed to load Available Certifications.' })
                            );
                            return of(jobQualificationActions.loadAvailableCertsFailure({ error: result }));
                        })
                    );
            })
        );
    });

    getRequirementsFromUD$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(jobQualificationActions.getRequirementsFromUD),
            switchMap((action) => {
                return this._service.getRequirementsFromUD(action.jobId).pipe(
                    map((result) => jobQualificationActions.getRequirementsFromUDSuccess({ qualifications: result })),
                    catchError((result) => {
                        this._store.dispatch(
                            showToasterMessage({ message: 'Failed to load Job Qualifications from UD.' })
                        );
                        return of(jobQualificationActions.getRequirementsFromUDFailure({ error: result }));
                    })
                );
            })
        );
    });
}
